import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import RestrictedRoute from '../../auth/RestrictedRoute'
import { CategoryPeriodListPage } from './CategoryPeriodListPage'
import EditCategoryPeriodPage from './EditCategoryPeriodPage'
import NewCategoryPeriodPage from './NewCategoryPeriodPage'

export default function CategoryPeriodPage() {
  const match = useRouteMatch()
  const path = match.path
  return (
    <Switch>
      <RestrictedRoute exact requiredPermission='nav_basic' path={path} component={CategoryPeriodListPage} />
      <RestrictedRoute exact requiredPermission='nav_basic' path={`${path}/uusi`} component={NewCategoryPeriodPage} />
      <RestrictedRoute
        exact
        requiredPermission='nav_basic'
        path={`${path}/:periodId/muokkaa`}
        component={EditCategoryPeriodPage}
      />
    </Switch>
  )
}
